import initLoggedShell from '@ep/tools/init.js';
import { installSystemScheduleActions } from '../actions/systemSchedules.js';
import { installModulePriceActions } from '../actions/modulePrices.js';

export default async function initLoggedPage() {
  installSystemScheduleActions();
  installModulePriceActions();
  await initLoggedShell();
}
